import { render, staticRenderFns } from "./BarAudio.vue?vue&type=template&id=569d7a55&scoped=true&"
import script from "./BarAudio.vue?vue&type=script&lang=js&"
export * from "./BarAudio.vue?vue&type=script&lang=js&"
import style0 from "./BarAudio.vue?vue&type=style&index=0&id=569d7a55&prod&scoped=true&lang=css&"
import style1 from "./BarAudio.vue?vue&type=style&index=1&id=569d7a55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d7a55",
  null
  
)

export default component.exports